import React, { useState, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Layout from "../components/layout"
import Hero from "../components/organisms/Hero"
import ProjectsList from "../components/organisms/ProjectsList"
import ProjectsFilters from "../components/organisms/ProjectsFilters"
import ContactUs from "../components/organisms/ContactUs"
import SEO from "../components/seo"

const query = graphql`
  {
    allStrapiCaseStudies(sort: { fields: order }) {
      nodes {
        title
        customUrl
        showCover
        id
        caseStudyExternalUrl
        caseStudyTitleText
        industry {
          name
        }
        scope {
          name
        }
        service {
          name
        }
        navigationImage {
          publicURL
        }
        imagesForProjectListing {
          image {
            childImageSharp {
              fluid(maxWidth: 1310, quality: 100) {
                ...GatsbyImageSharpFluid_noBase64
              }
            }
          }
        }
      }
    }
    allStrapiIndustries(sort: { fields: name }) {
      nodes {
        name
      }
    }
    allStrapiScopes(sort: { fields: name }) {
      nodes {
        name
      }
    }
    allStrapiServices(sort: { fields: name }) {
      nodes {
        name
      }
    }
    strapiProjects {
      seo {
        description
        ogImage {
          childImageSharp {
            fluid(maxWidth: 1200, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        title
      }
      sectionHeader {
        subtitle
        title
      }
      contactUs {
        title {
          subtitle
          title
        }
        buttons {
          title
        }
      }
    }
  }
`

// ***** REMOVED FROM GRAPHQL QUERY *****
// projectsInfo {
//   title
//   description
// }

const Work = () => {
  const [filteredProjects, setFilteredProjects] = useState([])
  const [shapedData, setShapedData] = useState([])
  const [isDesktop, setIsDesktop] = useState(true)
  const data = useStaticQuery(query)
  const caseStudies = data.allStrapiCaseStudies.nodes
  const contactUs = data.strapiProjects.contactUs
  const sectionHeader = data.strapiProjects.sectionHeader
  const seo = data.strapiProjects.seo
  // const infoTitle = data.strapiProjects.projectsInfo.title
  // const infoDescription = data.strapiProjects.projectsInfo.description

  let industries = caseStudies.map(study => {
    let elements = []
    if (study.industries && Array.isArray(study.industries)) {
      elements = study.industries.map(elem => elem)
    } else {
      elements.push(study.industries)
    }

    return elements
  })
  industries = [...new Set([].concat.apply([], industries))]
  industries = industries.sort()
  let scopes = caseStudies.map(study => {
    let elements = []
    if (study.scope && Array.isArray(study.scope)) {
      elements = study.scope.map(elem => elem)
    } else {
      elements.push(study.scope)
    }

    return [...new Set([].concat.apply([], elements.sort()))]
  })
  scopes = [...new Set([].concat.apply([], scopes))]
  scopes = scopes.sort()
  let services = caseStudies.map(study => {
    let elements = []
    if (study.services && Array.isArray(study.services)) {
      elements = study.services.map(elem => elem)
    } else {
      elements.push(study.services)
    }

    return [...new Set([].concat.apply([], elements.sort()))]
  })
  services = [...new Set([].concat.apply([], services))]
  services = services.sort()

  function checkDevice() {
    if (window.innerWidth > 768) {
      setIsDesktop(true)
    } else {
      setIsDesktop(false)
    }
  }

  useEffect(() => {
    checkDevice()
  }, [])

  useEffect(() => {
    window.addEventListener("resize", checkDevice)
    return () => {
      window.removeEventListener("resize", checkDevice)
    }
  })
  useEffect(() => {
    shapeData()
  }, [])

  function shapeData() {
    let data = [...caseStudies]

    data.map(element => {
      if (element.industry && !Array.isArray(element.industry)) {
        element.industries = Object.values(element.industry)
      } else {
        element.industries = element.industry?.map(elem => {
          return elem.name ? elem.name : elem
        })
      }
      if (element.scope && !Array.isArray(element.scope)) {
        element.scope = Object.values(element.scope)
      } else {
        element.scope = element.scope?.map(elem => {
          return elem.name ? elem.name : elem
        })
      }
      if (element.service && !Array.isArray(element.service)) {
        element.services = Object.values(element.service)
      } else {
        element.services = element.service?.map(elem => {
          return elem.name ? elem.name : elem
        })
      }
      setShapedData(data)
    })
  }

  function filterPojects(primaryFilter, secondaryFilters) {
    let projectsListing = [...shapedData]
    const tempArr = []
    if (secondaryFilters.length === 0) {
      setFilteredProjects(projectsListing)
    } else {
      const filteredProjectsArray = projectsListing.filter(elem => {
        let isElemActive = elem[primaryFilter].some(val =>
          secondaryFilters.includes(val)
        )
        let elemIndex = filteredProjects.indexOf(elem)
        if (isElemActive) {
          if (elemIndex !== -1) {
            return false
          } else {
            tempArr.push(elem)
          }
        } else {
          if (elemIndex !== -1) {
            setFilteredProjects(filteredProjects.splice(elemIndex, 1))
          }
        }
      })
      setFilteredProjects([...filteredProjects, ...tempArr])
    }
  }
  return (
    <Layout className="projects">
      <SEO
        image={seo.ogImage?.childImageSharp?.fluid?.src}
        title={seo.title}
        description={seo.description}
      />
      <Hero
        title={sectionHeader.title}
        subtitle={sectionHeader.subtitle}
        type="text"
        showClutchRev={false}
      />
      <ProjectsFilters
        isDesktop={isDesktop}
        filterCallback={filterPojects}
        filters={{
          industries: industries,
          scope: scopes,
          services: services,
        }}
      />
      <ProjectsList
        projects={filteredProjects.length > 0 ? filteredProjects : caseStudies}
        isDesktop={isDesktop}
        // infoDescription={infoDescription}
        // infoTitle={infoTitle}
      />
      <ContactUs
        title={contactUs.title.title}
        subtitle={contactUs.title.subtitle}
        contactUsLink={contactUs.buttons[0].link}
        contactUsTitle={contactUs.buttons[0].title}
        callUsLink={contactUs.buttons[1].link}
        callUsTitle={contactUs.buttons[1].title}
      />
    </Layout>
  )
}

export default Work
